import { Skeleton } from '@/components/ui/skeleton';

interface DataLoadingSkeletonProps {
  /** 'cards' = card placeholders, 'rows' = stacked row placeholders */
  variant?: 'cards' | 'rows';
  /** Number of skeleton items to render */
  count?: number;
  /**
   * When true, render skeleton items as bare siblings (no wrapping grid),
   * so the parent can control the layout. Use this when placing the
   * skeleton inside an existing grid.
   */
  bare?: boolean;
}

export default function DataLoadingSkeleton({ variant = 'cards', count = 3, bare = false }: DataLoadingSkeletonProps) {
  if (variant === 'rows') {
    const rows = Array.from({ length: count }).map((_, i) => (
      <div key={i} className="flex items-center gap-4 p-4 rounded-lg border border-border bg-card">
        <Skeleton className="h-5 w-5 rounded shrink-0" />
        <Skeleton className="h-4 flex-1" />
      </div>
    ));
    return bare ? <>{rows}</> : <div className="space-y-4">{rows}</div>;
  }

  const cards = Array.from({ length: count }).map((_, i) => (
    <div key={i} className="rounded-xl border border-border bg-card overflow-hidden">
      <Skeleton className="h-44 w-full rounded-none" />
      <div className="p-5 space-y-3">
        <Skeleton className="h-4 w-2/3" />
        <Skeleton className="h-3 w-full" />
        <Skeleton className="h-3 w-4/5" />
      </div>
    </div>
  ));

  return bare ? <>{cards}</> : (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {cards}
    </div>
  );
}
